import styles from './ClientAppeal.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {JSXSource} from "react/jsx-dev-runtime";
import WaitLoader from "../../WaitLoader/WaitLoader";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import {Link} from "react-router-dom";

interface AppealInt
{
    text:string
    author:string
    parent:number
    id:number
    createdAt:string
    reply:boolean
    type:number
    xData: string
    yData:string
}

export default function ClientAppeal()
{
    const appealData = useRef()
    const [ldrAppeal,rsAppeal,exAppeal] = useApiQuery("/appeal/client/list","post",appealData);

    const [appealOrder, setAppealOrder] = useState<AppealInt[]>([])
    const [appealRecall, setAppealRecall] = useState<AppealInt[]>([])
    const [appealRefund, setAppealRefund] = useState<AppealInt[]>([])

    const [showAppealOrderTree, setShowAppealOrderTree] = useState(false)
    const [showAppealRecallTree, setShowAppealRecallTree] = useState(false)
    const [showAppealRefundTree, setShowAppealRefundTree] = useState(false)

    const errorLineRef = useRef<ErrorLineItemRef>(null)


    useEffect(()=>{
        loadAppeal()
    },[appealData])

    const loadAppeal = () =>{
        exAppeal().then((e)=>{
            if(e?.success)
            {
                setAppealOrder(e?.payload?.appealOrder)
                setAppealRecall(e?.payload?.appealRecall)
                setAppealRefund(e?.payload?.appealRefund)

                console.log(e?.payload)
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)
        }).catch((e)=>{
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)

        })
    }


    const buildAppealRoot = (data:AppealInt[], mode:number) =>{
        const root =  data.filter((item)=> item?.parent === 0)
        const sb = root?.sort((a,b)=>{
            const dtA = new Date(a?.createdAt)
            const dtB = new Date(b?.createdAt)
            if(dtA < dtB) return 1
            if(dtA >  dtB) return -1
            return  0
        })
        if(sb?.length === 0) return  null
        return sb?.map((item,idx)=>{
            return(
                <div className={styles.appRoot} key={idx}>
                    {buildAppealTree(data,item, item.id,0,mode)}
                </div>
            )
        })


    }

    const buildAppealTree = (data: AppealInt[], item:AppealInt, id:number, level:number, mode:number)=>{
        let x = data.filter((item)=> item?.parent === id)
        x = x?.sort((a,b)=>{
            const dtA = new Date(a?.createdAt)
            const dtB = new Date(b?.createdAt)
            if(dtA < dtB) return -1
            if(dtA >  dtB) return 1
            return  0
        })


        const dt = new Date(item?.createdAt).toLocaleString()
        let showAddInfo = false
        let addInfo = ""
        switch (mode)
        {
            case 1:
                showAddInfo = true
                addInfo = `Заказ : ${item?.xData} ${ item?.yData ? '-> ' + item?.yData : ''}`
                break
            case 0:
                showAddInfo = true
                addInfo = `Заказ : ${item?.xData}`
                break

        }
        return(

            <div className={styles.appSub} style={{marginLeft:((level+1)*10)+"px"}}>
                <div className={styles.titleLine}>
                    <span className={styles.appAuthor}>{item?.author}</span>
                    <div>{dt}</div>

                </div>
                <div className={styles.apText}>{item?.text}</div>
                {showAddInfo && <div className={styles.apTextAdd}>{addInfo}</div>}

                <hr className={styles.appHr}></hr>
                {x?.map((itm,idx)=>{
                    return buildAppealTree(data,itm,itm?.id,level+1, mode)

                })}

            </div>

        )

    }

    return(
        <div className={styles.mainCont}>
            <WaitLoader loading={ldrAppeal} api={rsAppeal} onlyLoading={true}>
                <div className={styles.plCont}>
                    <div className={styles.xTitle}>
                        Здесь представлены результаты обработки Ваших обращений, новое обращение можно создать в
                        <Link to={"/lk/client/order/list"} className={styles.xTitleLink}>карточке заказа</Link>
                        выбрав соответсвующий заказ, если их несколько
                    </div>
                    <div className={styles.plLine}
                         onClick={()=>setShowAppealOrderTree(!showAppealOrderTree)}
                    >
                        <div className={styles.plRow}>Обращения по заказам</div>
                        <div>[ {appealOrder.length} ]</div>

                    </div>
                    { showAppealOrderTree &&
                        <div className={styles.appCont}>
                            {buildAppealRoot(appealOrder,0)}
                        </div>
                    }






                    <div className={styles.plLine}
                         onClick={()=>setShowAppealRecallTree(!showAppealRecallTree)}
                    >
                        <div className={styles.plRow}>Обращения по обратным звонкам</div>
                        <div>[ {appealRecall.length} ]</div>

                    </div>
                    { showAppealRecallTree &&
                        <div className={styles.appCont}>
                            {buildAppealRoot(appealRecall,1)}
                        </div>
                    }


                    <div className={styles.plLine}
                         onClick={()=>setShowAppealRefundTree(!showAppealRefundTree)}
                    >
                        <div className={styles.plRow}>Обращения по возвратам</div>
                        <div>[ {appealRefund.length} ]</div>

                    </div>
                    { showAppealRefundTree &&
                        <div className={styles.appCont}>
                            {buildAppealRoot(appealRefund,1)}
                        </div>
                    }

                </div>

            </WaitLoader>
            <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>





        </div>
    )
}